export const GOOGLE_DATASET_LOCATIONS: string[] = ['(unspecified)', 'US', 'EU', 'asia-northeast1'];